import React from 'react';
import Create from './pages/Create';
import Edit from './pages/Edit';
import Index from './pages/Index';
import { AppRouteProps } from '~/routes';

export default function DispatchClosedStatusRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/dispatch/closed-status', component: Index, isProtected: true, permissions: ['dispatch_closed_status_index']},
    {path: '/dispatch/closed-status/create', component: Create, isProtected: true, permissions: ['dispatch_closed_status_create']},
    {path: '/dispatch/closed-status/edit/:id', component: Edit, isProtected: true, permissions: ['dispatch_closed_status_edit']},

  ];

  return routes;
}
